import React, { Component } from "react";
import styled from "styled-components";
import { TableDefault } from '@loanbossinc/component-library';

const StyledTable = styled(TableDefault)`
  && {
    border-bottom: 1px solid #DADCE0;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
    box-shadow: none;
    font-size: 14px;
      
    table thead tr th {
      font-family: Work Sans;
      font-style: normal;
      font-weight: 600;
      font-size: 12px;
      line-height: 14px;
      color: #5F6368;
    }
  }
`;
const StyledNullContainer = styled.div`&& {
  /* Fill / White */

  background: #FFFFFF;
  /* Stroke / Gray */
  
  border: 1px solid #DADCE0;
  box-sizing: border-box;
  border-radius: 0px;
  height:63px;
}`;

const StyledNullMessage = styled.div`&& {
  /* Work Sans / 14 Regular */

  font-family: Work Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  display: flex;
  align-items: flex-end;
  margin-top: 25px;
  margin-left: 24px;

  /* Text / Dark Gray */
  
  color: #5F6368;
  
}`;
export class QuoteTable extends Component {


  mapData = () => {
    const { data } = this.props;
    const mapped = data.map(item => ({
      ...item
      , lender: {
        name: item && item['loanProvider.name']
        , loanType: item && item['loanType.name']
      }
      , ltvAndAmount: {
        amount: item && item['amount']
        , ltv: item && item['covenants.ltvStabilized']
      }
    }));
    return mapped;
  }

  render() {
    const { data, selectedQuote, noDataMessage, history, deal, columnOverride,columns, onRowClick} = this.props;

    if (!data || !data.length) 
    return (
      <StyledNullContainer>
        <StyledNullMessage>
          {noDataMessage}
        </StyledNullMessage>
      </StyledNullContainer>
    );

    return (
      <TableDefault
        columns={columns}
        onRowClick={onRowClick}
        items={this.mapData()}
        selectedItem={selectedQuote}
      />
    );
  }
}
